import type {ChatMessage} from '@Components/ai-chat-window/ai-chat-window.types';
import {ChatMessagePartType, MessageRole} from '@Components/ai-chat-window/ai-chat-window.types';
import {messagesAfter} from '@Components/ai-chat-window/lib/ai-chat-messages.library';

export const isPromptSentAfterMessage = (messages: Record<string, ChatMessage>, messageId: string, prompt: string): boolean => {
  return messagesAfter(messages, messageId).some((message) => isUserMessageCarrying(message, prompt));
};

const isUserMessageCarrying = (message: ChatMessage, prompt: string): boolean => {
  return message.role === MessageRole.USER && message.parts.some((part) => part.type === ChatMessagePartType.TEXT && part.text === prompt);
};
